<!-- Use preprocessors via the lang attribute! e.g. <template lang="pug"> -->
<template>
  <div>
    <div class="file-input-box w-100">
      <div class="wrapper-file-input">
        <div class="input-box" @click="openFileInput">
          <h4>
            <feather-icon
              icon="UploadIcon"
              svgClasses="stroke-current text-grey"
            />
            Choose File to upload
          </h4>
          <input
            ref="fileInput"
            type="file"
            hidden
            @change="handleFileChange"
            :multiple="isMultiple"
            :accept="acceptFormat"
          />
        </div>
        <small>Files Supported: {{ acceptFormat | formatString }}</small>
      </div>

      <div
        class="img-thumbs d-flex overflow-x-auto"
        v-if="selectedFiles.length"
      >
        <div
          class="wrapper-thumb"
          v-for="(f, index) in selectedFiles"
          :key="f.name"
        >
          <img
            v-if="f.isImage"
            :src="f.imageUrl"
            class="img-preview-thumb border border-dark rounded m-1"
          />
          <div
            v-else
            class="flex items-center justify-between p-2 border border-dark rounded doc m-1"
          >
            <span>{{ f.name }}</span>
          </div>

          <span class="remove-btn" @click="removeFile(index)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="size-6 close-icon"
            >
              <path
                fill-rule="evenodd"
                d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
                clip-rule="evenodd"
              />
            </svg>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  props: {
    acceptFormat: {
      type: Array,
      default: () => [],
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    maxFileSize: {
      type: Number,
    },
  },
  data() {
    return {
      selectedFiles: [],
    };
  },
  methods: {
    openFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const fileList = event.target.files;
      const files = [];
      if (!this.isMultiple) {
        this.selectedFiles = [];
      }

      const acceptedFormats = this.acceptFormat.map((format) =>
        format.toLowerCase()
      );

      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i];

        // FileSize Check
        if (this.maxFileSize && file.size > this.maxFileSize) {
          this.$vs.notify({
            text: `Selected file size should be less than ${(
              this.maxFileSize /
              (1024 * 1024)
            ).toFixed(0)}MB.`,
            color: "danger",
            position: "top-right",
          });
          return;
        }

        const fileExtension = file.name.split(".").pop().toLowerCase();

        if (acceptedFormats.includes(`.${fileExtension}`)) {
          this.selectedFiles.push({
            name: file.name,
            size: file.size,
            file: file,
            imageUrl: URL.createObjectURL(file),
            isImage: file.type.includes("image"),
          });
        } else {
          this.$vs.notify({
            text: `Accepting formats ${this.acceptFormat}`,
            color: "danger",
            position: "top-right",
          });
        }
      }
      this.$emit("fileChange", this.selectedFiles);
    },
    formatFileSize(size) {
      const units = ["B", "KB", "MB", "GB"];
      let index = 0;

      while (size >= 1024 && index < units.length - 1) {
        size /= 1024;
        index++;
      }

      return `${size.toFixed(2)} ${units[index]}`;
    },
    removeFile(index) {
      this.selectedFiles.splice(index, 1);
    },
    isImageFile(file) {
      return;
    },
  },
  filters: {
    formatString(data) {
      return data
        ? data.map((v) => _.upperCase(v.replace(".", ""))).join(", ")
        : "All";
    },
  },
};
</script>

<style lang="scss" scoped>
.file-input-box {
  display: flex;
  justify-content: center;
  flex-direction: column;
  border-radius: 10px;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.2);
  width: 600px;
  height: auto;
  background-color: #ffffff;
  padding: 20px;

  .input-box {
    padding: 20px;
    display: grid;
    place-items: center;
    border: 2px dashed #cacaca;
    border-radius: 5px;
    margin-bottom: 5px;
    cursor: pointer;
    h4 {
      margin: 0;
    }
  }
  small {
    font-size: 12px;
    color: #a3a3a3;
  }
  .wrapper-file-section {
    .selected-files {
      h5 {
        margin-bottom: 10px;
      }
      .file-list {
        overflow-y: auto;
        list-style-type: none;
        padding: 0 10px 10px 0;
        margin: 0;
        transition: 0.3s all ease-in-out;
        .item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border: 1px solid #cacaca;
          border-radius: 5px;
          padding: 10px;
          font-size: 14px;

          &:not(:last-child) {
            margin-bottom: 5px;
          }
          .remove {
            display: grid;
            place-items: center;
            color: #c0392b;
            cursor: pointer;
            transition: 0.3s all ease-in-out;
            &:hover {
              color: #e74c3c;
            }
          }
        }
      }
    }
  }
}

.img-thumbs {
  background: #eee;
  border: 1px solid #ccc;
  border-radius: 0.25rem;
  margin: 1.5rem 0;
  padding: 0.75rem;
}

.wrapper-thumb {
  position: relative;
  display: inline-block;
  margin: 1rem 0;
  justify-content: space-around;
}

.img-preview-thumb {
  background: #fff;
  border: 1px solid none;
  border-radius: 0.25rem;
  box-shadow: 0.125rem 0.125rem 0.0625rem rgba(0, 0, 0, 0.12);
  margin-right: 1rem;
  max-width: 140px;
  padding: 0.25rem;
}

.remove-btn {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.7rem;
  top: -5px;
  right: 10px;
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 10px;
  font-weight: bold;
  cursor: pointer;
  color: red;
}

.remove-btn:hover {
  box-shadow: 0px 0px 3px grey;
  transition: all 0.3s ease-in-out;
}

.doc {
  width: 200px;
  text-overflow: ellipsis;
}

.close-icon {
  width: 18px;
  height: 18px;
  font-weight: bolder;
  border: 1px solid red;
  border-radius: 50%;
  padding: 2px;
}
</style>
